import { useDataLayerAction } from '../TagContext'
import { useEffect } from 'react'
import { Maybe, ProductInterface } from '@pylot-data/fwrdschema'

export const usePdpTracking = (
    product?: Maybe<ProductInterface>,
    isValidating?: boolean
): void => {
    const dataLayerAction = useDataLayerAction()
    const isClient = typeof window !== 'undefined'
    const isPrmotionalProductTileClicked =
        isClient && localStorage!.getItem('promotionBanner')
    useEffect(() => {
        if (product && !isValidating) {
            dataLayerAction({
                type: 'PDP',
                data: product
            })
        }
        if (isPrmotionalProductTileClicked && product && !isValidating) {
            dataLayerAction({
                type: 'PROMOTION_CLICK',
                data: product
            })
        }
    }, [dataLayerAction, product])
}
